import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button, Dropdown, Form, Icon, Input, Menu, Tab, Table } from "semantic-ui-react";

import { DBB_TYRE_SET_TYPE, getTyreSeasonIcon } from "./../../../../../../modules/Appointments/common";
import { DEFAULT_PROFILE, TYRE_SET_POSITIONS, TYRE_SET_TYPES, getWheelTypeOptions } from "./../../utils";
import DBBTyreSearch from "./../DBBTyreSearch";

const getTyreSize = tyre => `${tyre.width}/${tyre.height}R${tyre.size}`;

const getTyreDescription = tyre => {
  if (!tyre) return "";

  return !tyre.description.includes(`${tyre.carry_capacity}${tyre.speed}`) ? `${tyre.description} ${tyre.carry_capacity}${tyre.speed}` : tyre.description;
};

class DBBTyreSetsSection extends Component {
  state = {
    addTyreTarget: null,
  };

  handleConfirmTyre = pickedTyre => {
    const { addTyreTarget } = this.state;
    if (!addTyreTarget) return;

    const { setIndex, position } = addTyreTarget;
    const tyres = this.props.tyreSets[setIndex].tyres.filter(tyre => tyre.position !== position);

    this.props.onChangeSetTyres(setIndex, [...tyres, { tyre: pickedTyre, position, profile: DEFAULT_PROFILE }]);
  };

  handleRemoveTyre = (setIndex, position) =>
    this.props.onChangeSetTyres(
      setIndex,
      this.props.tyreSets[setIndex].tyres.filter(tyre => tyre.position !== position)
    );

  handleCopyOverSet = (setIndex, tyreToCopy) =>
    this.props.onChangeSetTyres(
      setIndex,
      TYRE_SET_POSITIONS.map(({ position }) => ({ ...tyreToCopy, position }))
    );

  handleChangeProfile = (setIndex, position, value) => {
    const tyreIndex = this.props.tyreSets[setIndex].tyres.findIndex(tyre => tyre.position === position);
    if (tyreIndex === -1) return;

    const tyres = [...this.props.tyreSets[setIndex].tyres];
    tyres[tyreIndex] = { ...tyres[tyreIndex], profile: value === "" ? null : parseFloat(value) };

    this.props.onChangeSetTyres(setIndex, tyres);
  };

  renderRow = ({ position, label, defaultText }, set, setIndex) => {
    const { t } = this.props;
    const setTyre = set.tyres.find(tyre => tyre.position === position);

    return (
      <Table.Row key={position}>
        <Table.Cell>
          <div className="tyre-position">
            <Icon name="plus circle" color="blue" link onClick={() => this.setState({ addTyreTarget: { setIndex, position } })} />
            <span>{t(label).message || defaultText}</span>
          </div>
        </Table.Cell>
        <Table.Cell>
          {setTyre && (
            <div className="tyre-size">
              {getTyreSeasonIcon(setTyre.tyre.season)}
              {getTyreSize(setTyre.tyre)}
            </div>
          )}
        </Table.Cell>
        <Table.Cell>{getTyreDescription(setTyre?.tyre)}</Table.Cell>
        <Table.Cell>{setTyre?.tyre.ean}</Table.Cell>
        <Table.Cell>{setTyre?.tyre.manufacturer}</Table.Cell>
        <Table.Cell>
          {setTyre && (
            <div className="tyre-profile">
              <Input type="number" value={setTyre.profile ?? ""} onChange={(_e, { value }) => this.handleChangeProfile(setIndex, position, value)} />
              <span>mm</span>
            </div>
          )}
        </Table.Cell>
        <Table.Cell>
          {setTyre && (
            <div className="tyre-actions">
              <Button color="green" icon type="button" onClick={() => this.handleCopyOverSet(setIndex, setTyre)}>
                <Icon name="copy" />
              </Button>
              <Button basic icon type="button" onClick={() => this.handleRemoveTyre(setIndex, position)}>
                <Icon name="trash" color="red" />
              </Button>
            </div>
          )}
        </Table.Cell>
      </Table.Row>
    );
  };

  renderSet = (set, setIndex) => {
    const { hasValidationError, onChangeWheelType, storageLocationId, storageLocationOptions, isFetchingOptions, onChangeStorageLocation, t } = this.props;

    return (
      <div className="tyre-set">
        <Form.Group>
          <Form.Field width={4} required error={hasValidationError && !set.wheel_type}>
            <label>{t("wheel_type").message || "Wheel type"}</label>
            <Dropdown
              selection
              fluid
              selectOnBlur={false}
              placeholder={t("select_wheel_type").message || "Select wheel type"}
              options={getWheelTypeOptions(t)}
              value={set.wheel_type}
              onChange={(_e, { value }) => onChangeWheelType(setIndex, value)}
            />
          </Form.Field>
          {set.set_type === DBB_TYRE_SET_TYPE.STORAGE && (
            <Form.Field width={4} required error={hasValidationError && !storageLocationId}>
              <label>{t("storage_location").message || "Storage Location"}</label>
              <Dropdown
                selection
                fluid
                search
                selectOnBlur={false}
                loading={isFetchingOptions}
                placeholder={t("storage_location").message || "Storage Location"}
                options={storageLocationOptions}
                value={storageLocationId}
                onChange={(_e, { value }) => onChangeStorageLocation(value)}
              />
            </Form.Field>
          )}
        </Form.Group>

        <Table className="tyre-set-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{t("position").message || "Position"}</Table.HeaderCell>
              <Table.HeaderCell>{t("size").message || "Size"}</Table.HeaderCell>
              <Table.HeaderCell>{t("description").message || "Description"}</Table.HeaderCell>
              <Table.HeaderCell>EAN</Table.HeaderCell>
              <Table.HeaderCell>{t("brand").message || "Brand"}</Table.HeaderCell>
              <Table.HeaderCell>{t("profile").message || "Profile"}</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>{TYRE_SET_POSITIONS.map(position => this.renderRow(position, set, setIndex))}</Table.Body>
        </Table>
      </div>
    );
  };

  getTyreSetPanes = () => {
    const { tyreSets, hasValidationError, t } = this.props;

    return tyreSets.map((set, setIndex) => {
      const setLabel = TYRE_SET_TYPES.find(({ setType }) => setType === set.set_type);

      return {
        menuItem: (
          <Menu.Item key={set.set_type} className={hasValidationError && !set.wheel_type ? "has-error" : undefined}>
            {t(setLabel.label).message || setLabel.defaultText}
          </Menu.Item>
        ),
        render: () => this.renderSet(set, setIndex),
      };
    });
  };

  render() {
    const { car, location } = this.props;
    const { addTyreTarget } = this.state;

    return (
      <div className="tyre-sets-section">
        <Tab menu={{ secondary: true }} panes={this.getTyreSetPanes()} />

        <DBBTyreSearch car={car} location={location} open={!!addTyreTarget} onClose={() => this.setState({ addTyreTarget: null })} onConfirm={this.handleConfirmTyre} />
      </div>
    );
  }
}

export default withTranslation()(DBBTyreSetsSection);
